import React, { ReactNode } from 'react';
import { Box, KeyValue } from 'web-library';

interface ToggleDisplayEditFormItemProps {
  /**
   * id of component
   */
  id?: string;
  /**
   * indicate whether to display edit related components (EditComponentLabel and EditComponent) or
   * "view-only" component (labelText, isPreferredLabelText, valueText)
   */
  isEditState?: boolean;
  /**
   * indicate whether should hide "view-only" component even though isEditState is true
   */
  isHideDisplay?: boolean;
  /**
   * force hide component even though isEditState is true
   */
  allHide?: boolean;
  /**
   * "view-only" component
   */
  labelText?: string;
  /**
   * "view-only" component
   */
  isPreferredLabelText?: string;
  /**
   * "view-only" component
   */
  valueText?: string;

  /**
   * edit component
   */
  EditComponentLabel?: ReactNode;
  /**
   * edit component
   */
  EditComponent?: ReactNode;

  /**
   * class name for the container in edit and "view-only" state
   */
  containerClassName?: string;
}

/**
 * Will toggle between display and edit state depending on isEditState props.
 * It will not unmount the display and edit components but only set display to "none", hence the value for edit state component
 * is not resetted.
 */
const ToggleDisplayEditFormItem = ({
  id,
  isEditState = false,
  isHideDisplay = false,
  allHide = false,
  labelText = '-',
  isPreferredLabelText = '',
  valueText = '-',
  EditComponentLabel = null,
  EditComponent = null,
  containerClassName = undefined,
}: ToggleDisplayEditFormItemProps) => (
  <>
    <Box className={containerClassName} style={{ display: allHide  || !isEditState ? 'none' : undefined }}>
      {EditComponentLabel}
      {EditComponent}
    </Box>
    <Box
      className={`${containerClassName}`}
      style={{ display: !isEditState && !isHideDisplay && !allHide ? undefined : 'none', marginBottom: 0 }}
    >
      <KeyValue
        id={id}
        keyText={labelText}
        capitalize={false}
        keyIsPrefferedText={isPreferredLabelText}
        valueText={valueText || '-'}
      />
    </Box>
  </>
);

export default ToggleDisplayEditFormItem;
